export const en = ({
  breadcrumbs: {
    cards: 'Card index and lists',
    card_page: 'Person card',
  },
  page_title: 'Person card: {{fio}}',
  buttons: {
    'search by external id': {
      label: 'Search person',
    },
    'delete file': {
      tooltip: 'Delete file',
    },
    'download file': {
      tooltip: 'Download file',
    },
  },
  delete: {
    last_face: {
      title: 'Removing the last person',
      message: 'The card will be unpinned from the lists. Are you sure?',
    },
    list: {
      title: 'Exclude from list',
      message: 'Are you sure you want to exclude the card from the list {{listName}}?',
    },
  },
  empty: {
    no_faces: 'No data. Add faces.',
  },
  'face card': {
    buttons: {
      'face search button': {
        label: 'Search',
      },
    },
  },
  info: {
    'no data': 'No data',
  },
  'info block': {
    title: 'Common information',
    'card id': 'Card ID',
    fio: 'Full name',
    'date created': 'Date created',
  },
  'edit card': {
    title: 'Edit card',
    'input label': 'Full name',
    toast: {
      success: 'Card was successfully updated',
    },
  },
  filters: {
    popovers: {
      date: {
        label: 'Creation date',
      },
      'face ids': {
        label: 'Face IDs',
      },
      'user data': {
        label: 'User data',
      },
    },
    buttons: {
      'reset button': {
        label: 'Reset',
      },
    },
  },
  features: {
    attach_card_to_list: {
      title: 'Lists',
    },
    upload_file_form: {
      title: 'Add file',
      fields: {
        file: 'File',
        name: 'Name',
      },
      actions: {
        submit: 'Save',
        cancel: 'Cancel',
      },
    },
    person_files: {
      title: 'Files',
      empty: 'No data',
    },
  },
}) as Record<string, unknown>;
export const ru = ({
  breadcrumbs: {
    cards: 'Картотека и списки',
    card_page: 'Карточка персоны',
  },
  page_title: 'Карточка персоны: {{fio}}',
  buttons: {
    'search by external id': {
      label: 'Искать персону',
    },
    'delete file': {
      tooltip: 'Удалить файл',
    },
    'download file': {
      tooltip: 'Скачать файл',
    },
  },
  delete: {
    last_face: {
      title: 'Удаление последнего лица',
      message: 'Карточка будет откреплена от списков. Вы уверены?',
    },
    list: {
      title: 'Исключить из списка',
      message: 'Вы уверены, что хотите исключить карточку из списка {{listName}}?',
    },
  },
  empty: {
    no_faces: 'Нет данных. Добавьте лица.',
  },
  'face card': {
    buttons: {
      'face search button': {
        label: 'Искать',
      },
    },
  },
  info: {
    'no data': 'Нет данных',
  },
  'info block': {
    title: 'Общая информация',
    'card id': 'ID карточки',
    fio: 'ФИО',
    'date created': 'Создано',
  },
  'edit card': {
    title: 'Редактировать карточку',
    'input label': 'ФИО',
    toast: {
      success: 'Карточка успешно обновлена',
    },
  },
  filters: {
    popovers: {
      date: {
        label: 'Дата создания',
      },
      'face ids': {
        label: 'ID лиц',
      },
      'user data': {
        label: 'Информация',
      },
    },
    buttons: {
      'reset button': {
        label: 'Очистить',
      },
    },
  },
  features: {
    attach_card_to_list: {
      title: 'Списки',
    },
    upload_file_form: {
      title: 'Добавить файл',
      fields: {
        file: 'Файл',
        name: 'Название',
      },
      actions: {
        submit: 'Сохранить',
        cancel: 'Отмена',
      },
    },
    person_files: {
      title: 'Файлы',
      empty: 'Нет данных',
    },
  },
}) as Record<string, unknown>;
export const ptBr = ({
  breadcrumbs: {
    cards: 'Cartões e listas',
    card_page: 'Ficha de pessoa',
  },
  page_title: 'Ficha de pessoa: {{fio}}',
  buttons: {
    'search by external id': {
      label: 'Pesquisar pessoa',
    },
    'delete file': {
      tooltip: 'Excluir arquivo',
    },
    'download file': {
      tooltip: 'Baixar arquivo',
    },
    'attach card to list': {
      tooltip: 'Anexar à lista',
    },
  },
  delete: {
    last_face: {
      title: 'Removendo a última pessoa',
      message: 'O cartão será desvinculado das listas. Tem certeza?',
    },
    list: {
      title: 'Excluir da lista',
      message: 'Tem certeza de que deseja excluir o cartão da lista {{listName}}?',
    },
  },
  empty: {
    no_faces: 'Sem dados. Adicione faces.',
  },
  'face card': {
    buttons: {
      'face search button': {
        label: 'Pesquisar',
      },
    },
  },
  info: {
    'no data': 'Sem dados',
  },
  'info block': {
    title: 'Informação geral',
    'card id': 'ID do cartão',
    fio: 'Nome completo',
    'date created': 'Data de criação',
  },
  'edit card': {
    title: 'Editar cartão',
    'input label': 'Nome completo',
    toast: {
      success: 'O cartão foi atualizado com sucesso',
    },
  },
  filters: {
    popovers: {
      date: {
        label: 'Data de criação',
      },
      'face ids': {
        label: 'IDs de face',
      },
      'user data': {
        label: 'Dados do usuário',
      },
    },
    buttons: {
      'reset button': {
        label: 'Repor',
      },
    },
  },
  features: {
    'verify face': {
      modal: {
        title: 'Comparar faces',
        buttons: {
          verify: {
            label: 'Comparar',
          },
          clear: {
            label: 'Limpar',
          },
        },
      },
      'verify button': {
        label: 'Comparar',
      },
    },
    attach_card_to_list: {
      title: 'Listas',
    },
    upload_file_form: {
      title: 'Adicionar arquivo',
      fields: {
        file: 'Arquivo',
        name: 'Nome',
      },
      actions: {
        submit: 'Salvar',
        cancel: 'Cancelar',
      },
    },
    person_files: {
      title: 'Arquivos',
      empty: 'Sem dados',
    },
  },
}) as Record<string, unknown>;
export const esEs = ({
  breadcrumbs: {
    cards: 'Índice de tarjetas y listas',
    card_page: 'Tarjeta de persona',
  },
  page_title: 'Tarjeta de persona: {{fio}}',
  buttons: {
    'search by external id': {
      label: 'Buscar persona',
    },
    'delete file': {
      tooltip: 'Eliminar archivo',
    },
    'download file': {
      tooltip: 'Descargar archivo',
    },
    'attach card to list': {
      tooltip: 'Adjuntar a la lista',
    },
  },
  delete: {
    last_face: {
      title: 'Eliminando a la última persona',
      message: 'La tarjeta se desvinculará de las listas. ¿Está seguro?',
    },
    list: {
      title: 'Excluir de la lista',
      message: '¿Está seguro de que desea excluir la tarjeta de la lista {{listName}}?',
    },
  },
  empty: {
    no_faces: 'Sin datos. Agregue rostros.',
  },
  'face card': {
    buttons: {
      'face search button': {
        label: 'Buscar',
      },
    },
  },
  info: {
    'no data': 'Sin datos',
  },
  'info block': {
    title: 'Información común',
    'card id': 'ID de tarjeta',
    fio: 'Nombre completo',
    'date created': 'Fecha de creación',
  },
  'edit card': {
    title: 'Editar tarjeta',
    'input label': 'Nombre completo',
    toast: {
      success: 'La tarjeta se actualizó correctamente',
    },
  },
  filters: {
    popovers: {
      date: {
        label: 'Fecha de creación',
      },
      'face ids': {
        label: 'IDs de rostro',
      },
      'user data': {
        label: 'Datos de usuario',
      },
    },
    buttons: {
      'reset button': {
        label: 'Restablecer',
      },
    },
  },
  features: {
    'verify face': {
      modal: {
        title: 'Comparar rostros',
        buttons: {
          verify: {
            label: 'Comparar',
          },
          clear: {
            label: 'Limpiar',
          },
        },
      },
      'verify button': {
        label: 'Comparar',
      },
    },
    attach_card_to_list: {
      title: 'Listas',
    },
    upload_file_form: {
      title: 'Agregar archivo',
      fields: {
        file: 'Archivo',
        name: 'Nombre',
      },
      actions: {
        submit: 'Guardar',
        cancel: 'Cancelar',
      },
    },
    person_files: {
      title: 'Archivos',
      empty: 'Sin datos',
    },
  },
}) as Record<string, unknown>;
